module.exports = __webpack_public_path__ + "img/history.ac09b4c9.png";